import { Space, Typography } from 'antd';
import styled from 'styled-components';

export interface MedicalCardImageProps {
  imagePath: string;
}

export const MedicalCardImage = styled.div<MedicalCardImageProps>`
  background: url(${(props) => props.imagePath});
  background-size: cover;
  border: 1px solid var(--neutral-5);
  border-radius: 15px;
  width: 343px;
  height: 220px;
  padding-left: 43px;
  padding-top: 46px;
  padding-bottom: 15px;
  position: relative;
  display: grid;
  grid: repeat(7, 1fr) / auto 1fr 1fr;
  gap: 0 10px;
`;

export const MedicalCardHotlineSectionContainer = styled(Space)`
  bottom: 12px;
  grid-row: 6 / 8;
  grid-column: 1 / 4;
`;

interface MedicalCardTextRowValue {
  shrink?: boolean;
}

export const MedicalCardTextRowValue = styled(Typography.Text)<MedicalCardTextRowValue>`
  grid-column: ${(props) => (props.shrink ? '' : '2 / 4')};
`;

export const MedicalCardHospMOPText = styled(Typography.Text)`
  grid-column: 3 / 4;
  grid-row: 3 / 4;
`;
